/**
 * @generated SignedSource<<77db537363c0127fbf541b9b081b75b2>>
 * @lightSyntaxTransform
 * @nogrep
 */

/* tslint:disable */
/* eslint-disable */
// @ts-nocheck

import { Fragment, ReaderFragment } from 'relay-runtime';
import { FragmentRefs } from "relay-runtime";
export type HpSharedLocationsModuleItem_item$data = {
  readonly cta: string | null;
  readonly description: string | null;
  readonly imageHeight: string | null;
  readonly imageUrl: string | null;
  readonly imageWidth: string | null;
  readonly linkData: {
    readonly " $fragmentSpreads": FragmentRefs<"HpSharedModuleItemTile_linkData">;
  };
  readonly title: string | null;
  readonly " $fragmentType": "HpSharedLocationsModuleItem_item";
};
export type HpSharedLocationsModuleItem_item$key = {
  readonly " $data"?: HpSharedLocationsModuleItem_item$data;
  readonly " $fragmentSpreads": FragmentRefs<"HpSharedLocationsModuleItem_item">;
};

const node: ReaderFragment = {
  "argumentDefinitions": [],
  "kind": "Fragment",
  "metadata": null,
  "name": "HpSharedLocationsModuleItem_item",
  "selections": [
    {
      "alias": null,
      "args": null,
      "kind": "ScalarField",
      "name": "title",
      "storageKey": null
    },
    {
      "alias": null,
      "args": null,
      "kind": "ScalarField",
      "name": "description",
      "storageKey": null
    },
    {
      "alias": null,
      "args": null,
      "kind": "ScalarField",
      "name": "cta",
      "storageKey": null
    },
    {
      "alias": null,
      "args": null,
      "kind": "ScalarField",
      "name": "imageUrl",
      "storageKey": null
    },
    {
      "alias": null,
      "args": null,
      "kind": "ScalarField",
      "name": "imageHeight",
      "storageKey": null
    },
    {
      "alias": null,
      "args": null,
      "kind": "ScalarField",
      "name": "imageWidth",
      "storageKey": null
    },
    {
      "alias": null,
      "args": null,
      "concreteType": "LinkData",
      "kind": "LinkedField",
      "name": "linkData",
      "plural": false,
      "selections": [
        {
          "args": null,
          "kind": "FragmentSpread",
          "name": "HpSharedModuleItemTile_linkData"
        }
      ],
      "storageKey": null
    }
  ],
  "type": "Product",
  "abstractKey": null
};

(node as any).hash = "2fe9af44ea329e1613fbc43016e92361";

export default node;
